import { DataTable, Dialog, FormInput, Heading, Loader } from "@/components";
import { Button, Input, Textarea } from "@/components/ui";
import { Search } from "lucide-react";
import useProjectPlan from "./useProjectPlan";
import { FormProvider } from "react-hook-form";
import { NAME } from "./consts";

const ProjectPlan = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    planList,
    isPlanLoading,
    isMobile,
    onAdd,
    selectedPlan,
    onSubmitApproval,
    showConfirmation,
    setShowConfirmation,
    reason,
    onChangeReason,
    onConfirmSubmit,
    isUpdatePending,
    isApprovePlanExist,
    openAddPlanDialog,
    setOpenAddPlanDialog,
    onConfirmAddPlan,
    form,
    isAddPlanPending,
    isRevised
  } = useProjectPlan();
  const {errors} = form.formState;

  return (
    <div>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="" />
          {isMobile && !isApprovePlanExist && (
            <Button onClick={onAdd} className="px-2">
              + Add
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">

          <div className="flex flex-row items-center gap-4">
            {isApprovePlanExist ? <></> : <Button onClick={onSubmitApproval} disabled={!selectedPlan || isUpdatePending}>
              Submit For Approval
            </Button>}
            <Input
              type="text"
              placeholder="Search"
              value={globalFilter ?? ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="w-full sm:w-72 bg-white h-[40px]"
              startIcon={<Search className="w-4 h-4" />}
            />
            {!isMobile && !isApprovePlanExist && <Button onClick={onAdd}>+ Add</Button>}
          </div>
        </div>
      </div>

      {/* Responsive Table */}
      {isPlanLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(planList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
        </>
      )}
      <Dialog
        open={showConfirmation}
        setOpen={setShowConfirmation}
        title={isRevised.current ? "Revise Plan" : "Submit For Approval?"}
        onSave={onConfirmSubmit}
        saveText="Submit"
        contentClassName="lg:!max-w-[500px] lg:w-[500px]"
      >
        <div>
          {isRevised.current ? 
            <>
              Are you sure you want to revise this project plan?
              <br/>
              If yes, please provide a brief reason for your submission below.
            </> :
            <>Are you sure you want to submit this project plan for approval?<br/>If yes, please provide a brief reason for your submission below.</>
          }
          <div className="mt-5">
            <Textarea value={reason} onChange={onChangeReason} placeholder="Enter your reason here" className="h-[300px]" />
          </div>
        </div>
      </Dialog>
      <Dialog
        open={openAddPlanDialog}
        setOpen={setOpenAddPlanDialog}
        title="Add Plan" 
        onSave={form.handleSubmit(onConfirmAddPlan)}
        saveText="Save"
        isLoading={isAddPlanPending}
      >
        <div>
          <FormProvider {...form}>
            <form onSubmit={(e) => e.preventDefault()}>
              <FormInput
                name={NAME}
                control={form.control}
                label="Name"
                placeholder="Please enter"
                error={errors[NAME]?.message}
                isRequired
                maxLength={50}
              />
            </form>
          </FormProvider>
        </div>
      </Dialog>
    </div>
  );
};

export default ProjectPlan;
